import { Toaster as Sonner } from 'sonner';

interface ToastProviderProps {
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'top-center' | 'bottom-center';
  richColors?: boolean;
  closeButton?: boolean;
  expand?: boolean;
  duration?: number;
}

const ToastProvider = ({
  position = 'top-center',
  richColors = true,
  closeButton = true,
  expand = false,
  duration = 4000,
  ...props
}: ToastProviderProps) => {
  return (
    <Sonner
      position={position}
      richColors={richColors}
      closeButton={closeButton}
      expand={expand}
      duration={duration}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:font-medium',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          success: 'group-[.toaster]:border-green-500/30 group-[.toaster]:bg-green-50',
          error: 'group-[.toaster]:border-red-500/30 group-[.toaster]:bg-red-50',
          warning: 'group-[.toaster]:border-yellow-500/30 group-[.toaster]:bg-yellow-50',
          info: 'group-[.toaster]:border-blue-500/30 group-[.toaster]:bg-blue-50',
        },
      }}
      {...props}
    />
  );
};

export { ToastProvider };
export default ToastProvider;
export { toast } from '@/shared/api/toast';
